<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Gestion des règles de comptage</h2>
    <p class="page-subtitle">Configurez les seuils HT/BT pour les nouveaux projets</p>
  </div>
  <button (click)="openCreateDialog()" class="btn btn-primary btn-with-icon">
    <mat-icon aria-hidden="true">add</mat-icon>
    Nouvelle règle
  </button>
</div>

@if (errorMessage()) {
<div class="alert alert-error mb-4">
  {{ errorMessage() }}
  <button class="close-alert" (click)="errorMessage.set('')">×</button>
</div>
}

<div class="card shadow-sm mb-4">
  <div class="search-bar">
    <div class="search-bar-content">
      <div class="search-input-wrapper">
        <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (input)="onSearchChange(searchQuery)"
          placeholder="Rechercher une règle..."
          class="search-input"
        >
      </div>
      <div class="archived-toggle">
        <label class="checkbox-container">
          <input type="checkbox" [checked]="showArchived()" (change)="onToggleArchived()">
          <span class="checkmark"></span>
          Afficher les archivées
        </label>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <table class="modern-table" matSort (matSortChange)="onSortChange($event)" [matSortActive]="sortField">
      <thead>
        <tr>
          <th mat-sort-header="name">Nom de la règle</th>
          <th class="actions-cell">Statut</th>
        </tr>
      </thead>
      <tbody>
        @for (rule of pagedRules(); track rule.id) {
        <tr (click)="openEditDialog(rule)" class="clickable-row">
          <td class="font-bold">{{ rule.name }}</td>
          <td class="actions-cell">
            <div class="actions-wrapper">
              @if (rule.active) {
              <span class="active-badge">Active</span>
              } @else {
              <button (click)="onActivate(rule, $event)" class="btn btn-xs btn-outline">Activer</button>
              }
              @if (rule.archived) {
              <span class="badge-archived">Archivée</span>
              }
            </div>
          </td>
        </tr>
        } @empty {
        <tr class="empty-row">
          <td colspan="2">
            <div class="empty-state">
              <mat-icon class="empty-icon" aria-hidden="true">settings</mat-icon>
              <p>Aucune règle de comptage configurée</p>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <mat-paginator [length]="totalElements()"
                 [pageSize]="size()"
                 [pageSizeOptions]="[5, 10, 25, 100]"
                 (page)="onPageChange($event)"
                 aria-label="Sélectionner la page">
  </mat-paginator>
</div>

@if (isDialogOpen()) {
<app-comptage-rule-dialog [rule]="selectedRule()" (close)="closeDialog()" (saved)="onSaved()">
</app-comptage-rule-dialog>
}
